import type { RouteConfig } from 'vue-router';

const IntegrationRoutes: RouteConfig[] = [
	{
		path: '/integrations/cms',
		component: () => import(/* webpackChunkName: 'Integration' */ 'src/layouts/Integration.vue'),
		meta: {
			auth: 'required'
		},
		children: [
			{
				name: 'cms-integration',
				path: '',
				component: () => import(/* webpackChunkName: 'Integration' */ './cms/FormPicker.vue')
			}
		]
	}
];

export default IntegrationRoutes;
